import React from 'react';
import {withRouter} from "react-router-dom";
import {Col, FormGroup, Input, Label} from "reactstrap";

const DateSelect = (props) => {
  const {field, setField, selected, answerable, formDisabled, fieldNumber} = props
  const {title,description, index, required} = field

  const setValue = (e) => {
    const value = e.target.value
    setField({
      ...field,
      errors: {
        ...field.errors,
        required: answerable&&required&&value===''
      },
      value
    })
  }

  const checkErrors = (e) => {
    if (!answerable) return
    if (required) {
      if (field.value===''||field.value===null) {
        setField({
          ...field,
          errors: {
            required: true
          }
        })
      }
    }
  }

  const requiredError = field.errors&&field.errors.required
  const hasError = requiredError

  if ((!selected) || answerable) return <>

    <FormGroup row>
      <Col xs={12}>
        <Label for={`date-${index}`}>{fieldNumber+1}. {title} {required&&<b>*</b>} </Label>
        <div style={{fontSize: 12, marginTop: -8, marginBottom: 8, opacity: 0.8}}>{description}</div>
        <Input
          type='date'
          name={`date-${index}`}
          id={`date-${index}`}
          placeholder={description}
          disabled={formDisabled}
          onChange={setValue}
          onBlur={checkErrors}
          invalid={hasError}
          value={field.value}
        />
      </Col>
    </FormGroup>

  </>

  return <> </>
}

export default withRouter(DateSelect);
